import React, { useRef, useEffect, useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Card from '@material-ui/core/Card';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import MapContext from '../../../context/MapContext';
import StationCard from '../Intersection/StationCard';
import '../../../scss/components/_signal_planning.scss';
import TrafficTable from './TrafficTable';
import GeometryTable from './GeometryTable';
import AdjusmentTable from './AdjustmentTable';
import MovAnalysisTable from './MovAnalysisTable';
import Cookies from 'js-cookie';

import { isLogin, getPrivileges } from '../../../functions/Auth';
import API_PATH from "../../../constants/config.json";
import LaneGeometry from '../../DataManagement/LaneGeometry';
import GlobalScenarioCard from './GlobalScenarioCard';
import DataIconsTooltip from '../Tooltip/DataIconsTooltip';
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');
const AWS = require('aws-sdk');

const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
});

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#ffffff',
      padding: '4px',
      color: '#3f3f46',
      maxWidth: '412px',
      border: '1px solid #e4e4e7',
      fontSize: '12px',
      fontFamily: 'Inter-Regular',
      boxSizing: 'border-box',
      boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
      borderRadius: '4px'
    },
  }))(Tooltip);

let initialScenariosList = [];
let _laneConfigId = null;

const SignalPlanning = props => {

    const noCountDataTxt = "Add count data for this time period to generate a scenario";
    const dataNeededTxt = "Set lane geometry and upload count data to generate a scenario";
    const noLaneGeomTxt = "Please set lane geometry for the station to generate a scenario";
    const notApplicableTxt = "Global scenarios are only applicable to signal controlled intersections";
    
    _laneConfigId = props.stationData.FK_lane_config_id == null ? false : props.stationData.FK_lane_config_id;
    let pedCat = [];
    let capacityCat= [];
    const intersectionCapacity = 1650;
    const [actionInProgress, setActionInProgress] = useState(true);
    const [activeDate, setActiveDate] = useState("");
    const [activePeriod, setActivePeriod] = useState("");
    const [periodList, setPeriodList] = useState([]);
    const [isActiveScenarioId, setIsActiveScenarioId] = useState(null);
    const [activeScenarioId, setActiveScenarioId] = useState(null);
    const [activeScenarioObj, setActiveScenarioObj] = useState(null);
    const [descriptionScenario, setDescriptionScenario] = useState(null);
    const [activeData, setActiveData] = useState(null);
    const [capacityAssessment, setCapacityAssessment] = useState();
    const [isShared, setIsShared] = useState(false);
    const [editable, setEditable] = useState(false);
    const [showDownloadOpts, setShowDownloadOpts] = useState(false);
    const [showAdvancedOpt, setShowAdvancedOpt] = useState(false);
    const [showAdvancedInputs, setShowAdvancedInputs] = useState(false);
    const [scenariosList, setScenariosList] = useState([]);
    const [phasingList, setPhasingList] = useState([]);
    const [pedestrianCatalog, setPedestrianCatalog] = useState([]);
    const [capacityRatioCat, setCapacityRatioCat] = useState([]);

    const [criticalLaneVol, setCriticalLaneVol] = useState([]);
    const [checkVol, setCheckVol] = useState([]);
    const [leftCross, setLeftCross] = useState([]);
    const [oppApp, setOppApp] = useState([]);
    const [ehvValues, setEhvValues] = useState([]);
    const [eltValues, setEltValues] = useState([]);
    const [ertValues, setErtValues] = useState([]);
    const [epValues, setEpValues] = useState([]);
    const [eluValues, setEluValues] = useState([]);
    const [movFlowRate, setMovFlowRate] = useState([]);
    const [lgFlowRate, setLgFlowRate] = useState([]);
    const [sumLaneVolumes, setSumLaneVolumes] = useState(0);
    const [intCapacity, setIntCapacity] = useState(intersectionCapacity);
    const [lastEditedId, setLastEditedId] = useState(null);

    const [idintityPool, setIdintityPool] = useState('');
    const [aswLogins, setAswLogins] = useState('');

    const {updateStationDetails}=useContext(MapContext);

    const [showLaneConfig, setShowLaneConfig] = React.useState(false);
    const [laneConfigId, setLaneConfigId] = React.useState(_laneConfigId);
    const [readOnly, setReadOnly] = React.useState(false);

    const [globalDefaultTitle, setGlobalDefaultTitle] = useState("");
    const [globalDefaultDesc, setGlobalDefaultDesc] = useState("");
    
    useEffect(() => {
        if(props.stationData) {
            getAswToken();
            getSignalPhasingData();
            getCapacityRatio();
            setIsShared(props.sharedStation);

            if(!props.hasData && !props.stationData.FK_lane_config_id){
                setGlobalDefaultTitle("Data needed");
                setGlobalDefaultDesc(dataNeededTxt);
            } else if (!props.hasData && props.stationData.FK_lane_config_id) {
                setGlobalDefaultTitle("No count data");
                setGlobalDefaultDesc(noCountDataTxt);
            } else if (props.hasData && !props.stationData.FK_lane_config_id) {
                setGlobalDefaultTitle("No lane geometry");
                setGlobalDefaultDesc(noLaneGeomTxt);
            } else if (props.hasData && props.stationData.FK_lane_config_id) {
                if(props.stationData.control_type && props.stationData.control_type !== "Signal") {
                    setGlobalDefaultTitle("Not applicable");
                    setGlobalDefaultDesc(notApplicableTxt);
                } else {
                    setGlobalDefaultTitle("No count data");
                    setGlobalDefaultDesc(noCountDataTxt);
                }
            }
        }
    }, [props.stationData])
    
    useEffect(() => {        
        _laneConfigId = laneConfigId;
        if (_laneConfigId || laneConfigId)
            setReadOnly(true);
    }, [laneConfigId]);

    useEffect(() => {
        if(props.reloadScenarios || (props.newScenarioId !== null)) {
            getScenarios();
        }
    }, [props.reloadScenarios,props.newScenarioId])
    
    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                   
                } else {
                    console.log("");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    const gettingEmptyState = () => {
        return <div className='empty-state'>
            { !props.stationData.FK_lane_config_id
                ?
                <img src={require('../../../assets/icons/planning/lane_geometry_icon.svg')} />
                :
                <img src={require('../../../assets/icons/planning/file-add.svg')} />
            }
            <label>{ !props.stationData.FK_lane_config_id ? "No lane geometry set" : "No scenarios"}</label>
            {
                !props.stationData.FK_lane_config_id ?
                    getPrivileges().includes(1) ?
                    <p>Get started by setting the lane geometry for this station</p>
                    : null
                :
                <p>Get started by creating a new scenario!</p>
            }
            {
            (!laneConfigId) ? 
                getPrivileges().includes(1) ?
                <Button 
                    className='blue-btn create-sc-btn'
                    disabled={laneConfigId}
                    onClick={() => {setShowLaneConfig(true); setReadOnly(true)}}
                    style={{height: '38px'}}
                >
                    <img src={require('../../../assets/icons/intersection_primary.svg')} /> 
                    Set Lane Geometry</Button>
                : null
            :
            <Button 
                className='blue-btn create-sc-btn'
                disabled={props.sharedStation || !props.hasData || !props.stationData.FK_lane_config_id || !getPrivileges().includes(1)}
                onClick={() => props.setShowNewScenario(true)}
                style={{height: '38px'}}
            >
                <img src={require('../../../assets/icons/file_add.svg')} /> 
                Create scenario</Button>
            }
        </div>  
    }

    const getSignalPhasingData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.signalPhasingList,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setPhasingList(response.data.data);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getPedestrianVolume = async () => {
        try {
            let response = await axios({
                method: 'GET',
                url: API_URL + API_PATH.getPedestrianVolume,
            });
            if (response && response.status == 200) {
                setPedestrianCatalog(response.data.data);
                pedCat = response.data.data;
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getCapacityRatio = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getCapacityRatio,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        if(response.data.data)
                            setCapacityRatioCat(response.data.data);
                            capacityCat = response.data.data;
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {
            console.error(error);
        }
    }

    const getScenarios = () => {
        props.setReloadScenarios(false);
        setActionInProgress(true);
        setActiveData(null);
        setActiveDate("");
        setActivePeriod("");
        setActiveScenarioId(null);
        setActiveScenarioObj(null);
        setDescriptionScenario(null);
        let stationId = props.stationData.station_id;
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                },
                data: {
                    stationId
                },
                url: API_URL + API_PATH.getScenarioList,
            })
            .then(async function (response) {
                    if (response && response.status == '200') {
                        if(response.data.data) {
                            let data = response.data.data;
                            setScenariosList(data);
                            initialScenariosList= JSON.stringify(data);
                            let cActive = null;
                            data.forEach(function(rec) {
                                if(props.activeFromCard && props.activeFromCard === rec['scenario_id']){
                                    setIsActiveScenarioId(rec['scenario_id']);
                                    cActive = rec;
                                }
                            });
                            let scData = null;
                            if(data.length > 0 && !props.newScenarioId) {
                                scData = cActive ? cActive : data[0];
                                if(lastEditedId) {
                                    scData = gettingScenarioObj(lastEditedId, data);
                                    setLastEditedId(null);
                                }
                            } else if(props.newScenarioId) {
                                setActiveScenarioId(props.newScenarioId);
                                scData = gettingScenarioObj(props.newScenarioId, data);
                            } else if(data.length === 0) {
                                // setIsActiveScenarioId(null);
                                props.setNewScenarioId(null);
                            }
                            if(scData) {
                                setActiveScenarioId(scData['scenario_id']);
                                setActiveScenarioObj(scData);
                                setActiveData(scData.study_data_rw);
                                setDescriptionScenario(scData.description);
                                calculateGeometryTable(scData.study_data_rw, scData);
                                if(scData.date_count && scData.period) {
                                    setActiveDate(scData.date_count);
                                    setActivePeriod(scData.period);
                                    gettingPeriodList(scData.date_count);
                                } 
                                if(scData.intersection_capacity)
                                    setIntCapacity(scData.intersection_capacity);
                                else 
                                    setIntCapacity(intersectionCapacity);
                            }
                        }
                        setActionInProgress(false);
                    } 
                })
                .catch((err) => {
                    console.error(err);        
                    setActionInProgress(false);
                })
        } catch (error) {
            console.error(error);
            setActionInProgress(false);
        }
    }

    const gettingPeriodList = (currentDate) => {
        let dates = props.peakData;
        let list = [];
        dates.forEach(function(dt){
            let dtF = handleFormatDate(dt);
            if(dtF === currentDate) {
                if(dt.am.count > 0 ){
                    list.push("AM");
                }
                if(dt.mid.count > 0 ){
                    list.push("MID");
                }
                if(dt.pm.count > 0 ){
                    list.push("PM");
                }
            }
        });
        setPeriodList(list);
    }

    const gettingScenarioObj = (id, data=null) => {
        // getting scenario name
        let arr = data ? data : scenariosList;
        let filt = arr.filter( item => item.scenario_id === id);
        if(filt.length > 0) {
            setActiveScenarioObj(filt[0]);
            return filt[0];
        }
        return null;
    }

    const handleActionButton = () => {
        if(editable) {
            setActionInProgress(true);
            let data = activeScenarioObj;
            data.description = descriptionScenario;
            data.study_data_rw = activeData;
            data.date_count = activeDate;
            data.period = activePeriod;
            data.intersection_capacity = intCapacity;
            data.critical_flow_ratio = capacityAssessment;
            setLastEditedId(activeScenarioObj['scenario_id']);
            try {
                axios({
                    method: 'post',
                    headers: {
                        'payload': Cookies.get('payload'),
                    },
                    data,
                    url: API_URL + API_PATH.editScenario,
                })
                .then(async function (response) {
                        if (response && response.status == '200') {
                            setEditable(false);
                            // setActionInProgress(false);
                            // if(isActiveScenarioId === activeScenarioObj['scenario_id']) {
                            //     updateGeoLayer(data);
                            // }
                            getScenarios();
                            updateStationDetails({
                                station_id: props.stationData.station_id
                            });
                        } 
                    })
                    .catch((err) => {
                        setActionInProgress(false);
                        console.error(err);        
                    })
            } catch (error) {
                setActionInProgress(false);
                console.error(error);
            }
        } else {
            props.setShowNewScenario(true);
        }
    }

    const updateGeoLayer = (resSc) => {
        if(resSc) {
            let capacity = parseFloat(resSc['critical_flow_ratio']);
            let clasCap = 0;
            if(capacity < 0.85) {
                clasCap = 1;
            } else if (capacity >= 0.85 && capacity < 0.98){
                clasCap = 2;
            } else if (capacity >= 0.98) {
                clasCap = 3;
            } 
            updateStationDetails({
                activescenario : 1,
                capacityassessment: clasCap,
                station_id : props.stationData.station_id
            });
        } else {
            updateStationDetails({
                activescenario : 0,
                capacityassessment: 0,
                station_id : props.stationData.station_id
            });
        }
    }

    const handleChangeScenario = (e) => {
        let scenarioID = e.target.value;
        setActiveScenarioId(scenarioID);
        settingActiveInfo(scenarioID);
    }

    const handleChangeActiveScenario = (e) => {
        let scenarioID = e.target.value;
        // setIsActiveScenarioId(scenarioID);
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                },
                data: {
                    scenario_id: scenarioID,
                    station_id: props.stationData.station_id
                },
                url: API_URL + API_PATH.setActiveScenario,
            })
            .then(async function (response) {
                    if (response && response.status == '200') {
                        let resSc = gettingScenarioObj(scenarioID);
                        updateGeoLayer(resSc);
                    } 
                })
                .catch((err) => {
                    setActionInProgress(false);
                    console.error(err);        
                })
        } catch (error) {
            setActionInProgress(false);
            console.error(error);
        }
    }

    const handleChangeDate = (e) => {
        let date = e.target.value;
        setActiveDate(date);
        setActivePeriod("");
        gettingPeriodList(date);
    }

    const handleChangePeriod = (e) => {
        let period = e.target.value;
        setActivePeriod(period);
        gettingInfoByDate(period);
    }
    
    const gettingInfoByDate = (period=null, date=null, id=null) => {
        setActionInProgress(true);
        // getting information by date
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                },
                data: {
                    scenario_id: id ? id : activeScenarioId,
                    date_count: date ? date : activeDate,
                    period: period ? period : activePeriod
                },
                url: API_URL + API_PATH.getScenario,
            })
            .then(async function (response) {
                    if (response && response.status == '200') {
                        setActionInProgress(false);
                        if(response.data.data) {
                            let data = response.data.data
                            setActiveScenarioObj(data);
                            setDescriptionScenario(data.description);
                            setActiveData(data.study_data_rw);
                            // setActiveDate(data['date_count']);
                            // setActivePeriod(data['period']);
                            calculateGeometryTable(data.study_data_rw, data);
                            if(data.intersection_capacity)
                                setIntCapacity(data.intersection_capacity);
                            else
                                setIntCapacity(intersectionCapacity);
                        }
                    } 
                })
                .catch((err) => {
                    setActionInProgress(false);
                    console.error(err);        
                })
        } catch (error) {
            setActionInProgress(false);
            console.error(error);
        }
    }

    const handleCancel = () => {
        if(editable) {
            settingActiveInfo(activeScenarioId);
        }
        setEditable(!editable)
        
    }

    const handleClearInfo = () => {
        // set initial data
        settingActiveInfo(activeScenarioId);
    }

    const settingActiveInfo = (scenarioID) => {
        setActionInProgress(true);
        setTimeout(function(){
            let tmpInit = JSON.parse(initialScenariosList);
            let sc = gettingScenarioObj(scenarioID, tmpInit);
            setDescriptionScenario(sc.description);
            if(sc['study_data_rw']) {
                setActiveData(sc['study_data_rw']);
                calculateGeometryTable(sc['study_data_rw'], sc);
            }
            if(sc['date_count'] && sc['period']) {
                setActiveDate(sc['date_count']);
                setActivePeriod(sc['period']);
            } 
            if(sc['intersection_capacity'])
                setIntCapacity(sc['intersection_capacity']);
            else 
                setIntCapacity(intersectionCapacity);
            
            setActionInProgress(false);
        }, 2000);
    }

    const handleDeleteScenario = () => {
        props.setScenarioToDelete(activeScenarioObj);
        props.setShowDeleteScenario(true);
        setLastEditedId(null);
        updateStationDetails({
            station_id: props.stationData.station_id
        });
    }

    const calculateGeometryTable = (data, lastObj=null) => {
        let objVehicles = data['peak_15_min_flowrate']['all_vehicle'];
        let objLanes = data['lanes_in_lane_group'];
        let obj = {};
        obj['NB'] = objVehicles['NB Left'] > 240 ? true : false;
        obj['SB'] = objVehicles['SB Left'] > 240 ? true : false;
        obj['EB'] = objVehicles['EB Left'] > 240 ? true : false;
        obj['WB'] = objVehicles['WB Left'] > 240 ? true : false;
        setCheckVol(obj);

        if(objLanes['NB']) {
            // calculating left cross product
            let objCross = {};
            let dir = ['NB', 'SB', 'EB', 'WB'];
            dir.forEach(function(d, ind) {
                let lanesT = ind===0 ? objLanes['SB']['thru'] : ind===1 ? objLanes['NB']['thru'] : ind===2 ? objLanes['WB']['thru'] : objLanes['EB']['thru'];
                let lanesR = ind===0 ? objLanes['SB']['right'] : ind===1 ? objLanes['NB']['right'] : ind===2 ? objLanes['WB']['right'] : objLanes['EB']['right'];
                let volL = ind===0 ? objVehicles['NB Left'] : ind===1 ? objVehicles['SB Left'] : ind===2 ? objVehicles['EB Left'] : objVehicles['WB Left'];
                let volT = ind===0 ? objVehicles['SB Thru'] : ind===1  ? objVehicles['NB Thru'] : ind===2 ? objVehicles['WB Thru'] : objVehicles['EB Thru'];
                let volR = ind===0 ? objVehicles['SB Right'] : ind===1  ? objVehicles['NB Right'] : ind===2 ? objVehicles['WB Right'] : objVehicles['EB Right'];
                if(lanesR > 0) {
                    if(lanesT !== 0) {
                        if(lanesT === 1 && (volL*volT)>50000) {
                            objCross[d] = true;
                        } else {
                            if(lanesT === 2 && (volL*volT)>90000) {
                                objCross[d] = true;
                            } else {
                                if((volL*volT)>110000) {
                                    objCross[d] = true;
                                } else {
                                    objCross[d] = false;
                                }
                            }
                        }
                    } else {
                        objCross[d] = false;
                    }
                } else {
                    if(lanesT !== 0) {
                        if(lanesT === 1 && (volL * (volT+volR)) > 50000) {
                            objCross[d] = true;
                        } else {
                            if(lanesT === 2 && (volL * (volT+volR)) > 90000) {
                                objCross[d] = true;
                            } else {
                                if((volL * (volT+volR)) > 110000) {
                                    objCross[d] = true;
                                } else {
                                    objCross[d] = false;
                                }
                            }
                        }
                    } else {
                        objCross[d] = false;
                    }
                }
                
            });
            setLeftCross(objCross);
            // calculating left lanes grater than 1
            data['lanes_in_lane_group']['NB']['left_lanes_greater'] = data['lanes_in_lane_group']['NB']['left'] && data['lanes_in_lane_group']['NB']['left'] > 1 ? true : false;
            data['lanes_in_lane_group']['SB']['left_lanes_greater'] = data['lanes_in_lane_group']['SB']['left'] && data['lanes_in_lane_group']['SB']['left'] > 1 ? true : false;
            data['lanes_in_lane_group']['EB']['left_lanes_greater'] = data['lanes_in_lane_group']['EB']['left'] && data['lanes_in_lane_group']['EB']['left'] > 1 ? true : false;
            data['lanes_in_lane_group']['WB']['left_lanes_greater'] = data['lanes_in_lane_group']['WB']['left'] && data['lanes_in_lane_group']['WB']['left'] > 1 ? true : false;
            // calculating Ex. LT + Opp. App. Prot.
            let objOpp = {};
            dir.forEach(function(d, ind) {
                let lanesGroup = ind===0 ? objLanes['NB']['left'] : ind===1 ? objLanes['SB']['left'] : ind===2 ? objLanes['EB']['left'] : objLanes['WB']['left'];
                let leftCheckVol = ind===0 ? obj['SB'] : ind===1 ? obj['NB'] : ind===2 ? obj['WB'] : obj['EB'];
                let leftCrossP = ind===0 ? objCross['SB'] : ind===1 ? objCross['NB'] : ind===2 ? objCross['WB'] : objCross['EB'];
                let leftLanes = ind===0 ? objLanes['SB']['left_lanes_greater'] : ind===1 ? objLanes['NB']['left_lanes_greater'] : ind===2 ? objLanes['WB']['left_lanes_greater'] : objLanes['EB']['left_lanes_greater'];
                if(lanesGroup >= 1 && (leftCheckVol || leftCrossP || leftLanes)) {
                    objOpp[d] = true;    
                } else {
                    objOpp[d] = false;
                }
            });
            setOppApp(objOpp);

            // right phasing default value
            if(data['lanes_in_lane_group']['NB']['right_phasing'] === null) {
                data['lanes_in_lane_group']['NB']['right_phasing'] = 0;
            }
            if(data['lanes_in_lane_group']['SB']['right_phasing'] === null) {
                data['lanes_in_lane_group']['SB']['right_phasing'] = 0;
            }
            if(data['lanes_in_lane_group']['EB']['right_phasing'] === null) {
                data['lanes_in_lane_group']['EB']['right_phasing'] = 0;
            }
            if(data['lanes_in_lane_group']['WB']['right_phasing'] === null) {
                data['lanes_in_lane_group']['WB']['right_phasing'] = 0;
            }
            // left phasing default value
            if(data['lanes_in_lane_group']['NB']['left_phasing'] === null) {
                if(obj['NB'] || objCross['NB'] || data['lanes_in_lane_group']['NB']['left_lanes_greater'] || objOpp['NB']){
                    data['lanes_in_lane_group']['NB']['left_phasing'] = 1;
                } else {
                    data['lanes_in_lane_group']['NB']['left_phasing'] = 0;
                }
            }
            if(data['lanes_in_lane_group']['SB']['left_phasing'] === null) {
                if(obj['SB'] || objCross['SB'] || data['lanes_in_lane_group']['SB']['left_lanes_greater'] || objOpp['SB']){
                    data['lanes_in_lane_group']['SB']['left_phasing'] = 1;
                } else {
                    data['lanes_in_lane_group']['SB']['left_phasing'] = 0;
                }
            }
            if(data['lanes_in_lane_group']['EB']['left_phasing'] === null) {
                if(obj['EB'] || objCross['EB'] || data['lanes_in_lane_group']['EB']['left_lanes_greater'] || objOpp['EB']){
                    data['lanes_in_lane_group']['EB']['left_phasing'] = 1;
                } else {
                    data['lanes_in_lane_group']['EB']['left_phasing'] = 0;
                }
            }
            if(data['lanes_in_lane_group']['WB']['left_phasing'] === null) {
                if(obj['WB'] || objCross['WB'] || data['lanes_in_lane_group']['WB']['left_lanes_greater'] || objOpp['WB']){
                    data['lanes_in_lane_group']['WB']['left_phasing'] = 1;
                } else {
                    data['lanes_in_lane_group']['WB']['left_phasing'] = 0;
                }
            }

            calculateAdjusmentTable(data, lastObj);
        }
    }

    const calculateAdjusmentTable = async (data, lastObj) => {
        await getPedestrianVolume();
        let objHeavy = data['peak_15_min_flowrate']['heavy_trucks'];
        let objVehicles = data['peak_15_min_flowrate']['all_vehicle'];
        let objEOthert = data['adjustment_factors']['eother'];
        let objLanes = data['lanes_in_lane_group'];
        let dir = ['NB', 'SB', 'EB', 'WB'];
        if(objLanes['NB']) {
            let objEhv = {
                'NBLeft': parseFloat(objHeavy['NB Left'])+1,
                'NBThru': parseFloat(objHeavy['NB Thru'])+1,
                'NBRight': parseFloat(objHeavy['NB Right'])+1,
                'SBLeft': parseFloat(objHeavy['SB Left'])+1,
                'SBThru': parseFloat(objHeavy['SB Thru'])+1,
                'SBRight': parseFloat(objHeavy['SB Right'])+1,
                'EBLeft': parseFloat(objHeavy['EB Left'])+1,
                'EBThru': parseFloat(objHeavy['EB Thru'])+1,
                'EBRight': parseFloat(objHeavy['EB Right'])+1,
                'WBLeft': parseFloat(objHeavy['WB Left'])+1,
                'WBThru': parseFloat(objHeavy['WB Thru'])+1,
                'WBRight': parseFloat(objHeavy['WB Right'])+1
            };
            setEhvValues(objEhv);
            let objElt = {};
            // calculating ELT values
            dir.forEach(function(d, ind) {
                let lphasing = ind===0 ? objLanes['NB']['left_phasing'] : ind===1 ? objLanes['SB']['left_phasing'] : ind===2 ? objLanes['EB']['left_phasing'] : objLanes['WB']['left_phasing'];
                let sum1 = ind===0 ? objVehicles['SB Thru'] : ind===1 ? objVehicles['NB Thru'] : ind===2 ? objVehicles['WB Thru'] : objVehicles['EB Thru'];
                let sum2 = ind===0 ? objVehicles['SB Right'] : ind===1 ? objVehicles['NB Right'] : ind===2 ? objVehicles['WB Right'] : objVehicles['EB Right'];
                // 1 = protected
                if(lphasing === 1) {
                    objElt[d+'Left'] = 1.05;
                } else {
                    let sum = sum1+sum2;
                    objElt[d+'Left'] = findV(sum);
                }
                objElt[d+'Thru'] = 1;
                objElt[d+'Right'] = 1;
            });
            setEltValues(objElt);
            let objErt = {};
            // calculating ERT values
            dir.forEach(function(d, ind) {
                let rphasing = ind===0 ? objLanes['NB']['right_phasing'] : ind===1 ? objLanes['SB']['right_phasing'] : ind===2 ? objLanes['EB']['right_phasing'] : objLanes['WB']['right_phasing'];
                let pedVol = ind===0 ? data['peak_15_min_flowrate']['pedestrians']['NB Thru'] : ind===1 ? data['peak_15_min_flowrate']['pedestrians']['SB Thru'] : ind===2 ? data['peak_15_min_flowrate']['pedestrians']['EB Thru'] : data['peak_15_min_flowrate']['pedestrians']['WB Thru'];
                // 1 = protected
                if(rphasing === 1) {
                    objErt[d+'Right'] = 1.05;
                } else {
                    objErt[d+'Right'] = findPedVol(pedVol);
                }
                objErt[d+'Left'] = 1.00;
                objErt[d+'Thru'] = 1.00;
            });
            setErtValues(objErt);
            // calculating EP values
            let objEP = {};
            dir.forEach(function(d, ind) {
                let parkingAct = objLanes[d]['parking'];
                let leftLaneGroup = objLanes[d]['left'];
                let rightLaneGroup = objLanes[d]['right'];
                let thruLaneGroup = objLanes[d]['thru'];
                if(!parkingAct) {
                    objEP[d+'Left'] = 1.00;
                    objEP[d+'Thru'] = 1.00;
                    objEP[d+'Right'] = 1.00;
                } else {
                    if(leftLaneGroup===0 && rightLaneGroup===0) {
                        objEP[d+'Left'] = findParking(thruLaneGroup);
                    } else {
                        objEP[d+'Left'] = 1.00;
                    }
        
                    if(rightLaneGroup > 0) {
                        objEP[d+'Thru'] = 1.00;
                    } else {
                        objEP[d+'Thru'] = findParking(thruLaneGroup);
                    }
        
                    if(rightLaneGroup === 0) {
                        objEP[d+'Right'] = findParking(thruLaneGroup);
                    } else {
                        objEP[d+'Right'] = findParking(rightLaneGroup);
                    }
                }
            });
            setEpValues(objEP);
            // calculating ELU values
            let objElu = {};
            dir.forEach(function(d, ind) {
                let leftLaneGroup = objLanes[d]['left'];
                let rightLaneGroup = objLanes[d]['right'];
                let thruLaneGroup = objLanes[d]['thru'];
                if(leftLaneGroup === 1) {
                    objElu[d+'Left'] = 1.00;
                } else {
                    if(leftLaneGroup > 1) {
                        objElu[d+'Left'] = 1.03;
                    } else {
                        if(thruLaneGroup === 2) {
                            objElu[d+'Left'] = 1.05;
                        } else {
                            if(thruLaneGroup > 2) {
                                objElu[d+'Left'] = 1.1;
                            } else {
                                objElu[d+'Left'] = 1.00;
                            }
                        }
                    }
                }
    
                if(thruLaneGroup === 2) {
                    objElu[d+'Thru'] = 1.05;
                } else {
                    if(thruLaneGroup > 2) {
                        objElu[d+'Thru'] = 1.1;
                    } else 
                        objElu[d+'Thru'] = 1.00;
                }
    
                if(rightLaneGroup === 1) {
                    objElu[d+'Right'] = 1.00;
                } else {
                    if(rightLaneGroup > 1) {
                        objElu[d+'Right'] = 1.13;
                    } else {
                        if(thruLaneGroup === 2) {
                            objElu[d+'Right'] = 1.05;
                        } else {
                            if(thruLaneGroup > 2) {
                                objElu[d+'Right'] = 1.1;
                            } else {
                                objElu[d+'Right'] = 1.00;
                            }
                        }
                    }
                }
            });
            setEluValues(objElu);
            // formatting eother values
            objEOthert['NB Left'] = objEOthert['NB Left']===1 ? parseFloat(objEOthert['NB Left']).toFixed(2) : objEOthert['NB Left'];
            objEOthert['NB Thru'] = objEOthert['NB Thru']===1 ? parseFloat(objEOthert['NB Thru']).toFixed(2) : objEOthert['NB Thru'];
            objEOthert['NB Right'] = objEOthert['NB Right']===1 ? parseFloat(objEOthert['NB Right']).toFixed(2) : objEOthert['NB Right'];
            objEOthert['SB Left'] = objEOthert['SB Left']===1 ? parseFloat(objEOthert['SB Left']).toFixed(2) : objEOthert['SB Left'];
            objEOthert['SB Thru'] = objEOthert['SB Thru']===1 ? parseFloat(objEOthert['SB Thru']).toFixed(2) : objEOthert['SB Thru'];
            objEOthert['SB Right'] = objEOthert['SB Right']===1 ? parseFloat(objEOthert['SB Right']).toFixed(2) : objEOthert['SB Right'];
            objEOthert['EB Left'] = objEOthert['EB Left']===1 ? parseFloat(objEOthert['EB Left']).toFixed(2) : objEOthert['EB Left'];
            objEOthert['EB Thru'] = objEOthert['EB Thru']===1 ? parseFloat(objEOthert['EB Thru']).toFixed(2) : objEOthert['EB Thru'];
            objEOthert['EB Right'] = objEOthert['EB Right']===1 ? parseFloat(objEOthert['EB Right']).toFixed(2) : objEOthert['EB Right'];
            objEOthert['WB Left'] = objEOthert['WB Left']===1 ? parseFloat(objEOthert['WB Left']).toFixed(2) : objEOthert['WB Left'];
            objEOthert['WB Thru'] = objEOthert['WB Thru']===1 ? parseFloat(objEOthert['WB Thru']).toFixed(2) : objEOthert['WB Thru'];
            objEOthert['WB Right'] = objEOthert['WB Right']===1 ? parseFloat(objEOthert['WB Right']).toFixed(2) : objEOthert['WB Right'];
            // calculating movement flow rate
            let objMovRate = {
                'NBLeft': Math.round(objVehicles['NB Left']*objEhv['NBLeft']*objElt['NBLeft']*objErt['NBLeft']*objEP['NBLeft']*objElu['NBLeft']*objEOthert['NB Left']),
                'NBThru': Math.round(objVehicles['NB Thru']*objEhv['NBThru']*objElt['NBThru']*objErt['NBThru']*objEP['NBThru']*objElu['NBThru']*objEOthert['NB Thru']),//+0.00001,
                'NBRight': Math.round(objVehicles['NB Right']*objEhv['NBRight']*objElt['NBRight']*objErt['NBRight']*objEP['NBRight']*objElu['NBRight']*objEOthert['NB Right']),//+0.00002,
                'SBLeft': Math.round(objVehicles['SB Left']*objEhv['SBLeft']*objElt['SBLeft']*objErt['SBLeft']*objEP['SBLeft']*objElu['SBLeft']*objEOthert['SB Left']),//+0.00003,
                'SBThru': Math.round(objVehicles['SB Thru']*objEhv['SBThru']*objElt['SBThru']*objErt['SBThru']*objEP['SBThru']*objElu['SBThru']*objEOthert['SB Thru']),//+0.00004,
                'SBRight': Math.round(objVehicles['SB Right']*objEhv['SBRight']*objElt['SBRight']*objErt['SBRight']*objEP['SBRight']*objElu['SBRight']*objEOthert['SB Right']),//+0.00005,
                'EBLeft': Math.round(objVehicles['EB Left']*objEhv['EBLeft']*objElt['EBLeft']*objErt['EBLeft']*objEP['EBLeft']*objElu['EBLeft']*objEOthert['EB Left']),
                'EBThru': Math.round(objVehicles['EB Thru']*objEhv['EBThru']*objElt['EBThru']*objErt['EBThru']*objEP['EBThru']*objElu['EBThru']*objEOthert['EB Thru']),//+0.00001,
                'EBRight': Math.round(objVehicles['EB Right']*objEhv['EBRight']*objElt['EBRight']*objErt['EBRight']*objEP['EBRight']*objElu['EBRight']*objEOthert['EB Right']),//+0.00002,
                'WBLeft': Math.round(objVehicles['WB Left']*objEhv['WBLeft']*objElt['WBLeft']*objErt['WBLeft']*objEP['WBLeft']*objElu['WBLeft']*objEOthert['WB Left']),//+0.00003,
                'WBThru': Math.round(objVehicles['WB Thru']*objEhv['WBThru']*objElt['WBThru']*objErt['WBThru']*objEP['WBThru']*objElu['WBThru']*objEOthert['WB Thru']),//+0.00004,
                'WBRight': Math.round(objVehicles['WB Right']*objEhv['WBRight']*objElt['WBRight']*objErt['WBRight']*objEP['WBRight']*objElu['WBRight']*objEOthert['WB Right']),//+0.00005
            }
            setMovFlowRate(objMovRate);
            // calculating lane group flow rate
            let lgThru = {};
            dir.forEach(function(d, ind) {
                if(objLanes[d]['thru'] !== 0) {
                    if(objLanes[d]['left'] === 0 && objLanes[d]['right'] === 0) {
                        lgThru[d+'Thru'] = (objMovRate[d+'Left']+objMovRate[d+'Thru']+objMovRate[d+'Right'])/objLanes[d]['thru'];
                    } else {
                        if(objLanes[d]['left'] !== 0 && objLanes[d]['right'] === 0) {
                            lgThru[d+'Thru'] = (objMovRate[d+'Thru']+objMovRate[d+'Right'])/objLanes[d]['thru'];
                        } else {
                            if(objLanes[d]['left'] === 0 && objLanes[d]['right'] !== 0) {
                                lgThru[d+'Thru'] = (objMovRate[d+'Left']+objMovRate[d+'Thru'])/objLanes[d]['thru'];
                            } else {
                                lgThru[d+'Thru'] = (objMovRate[d+'Thru'])/objLanes[d]['thru'];
                            }
                        }
                    }
                } else {
                    lgThru[d+'Thru'] = 0;
                }
            });
            
            let objLgRate = {
                'NBLeft': objLanes['NB']['left'] > 0 ? objMovRate['NBLeft']/objLanes['NB']['left'] : 0,
                'NBThru': lgThru && lgThru['NBThru'] ? lgThru['NBThru'] : 0,
                'NBRight': objLanes['NB']['right'] > 0 ? objMovRate['NBRight']/objLanes['NB']['right'] : 0,
                'SBLeft': objLanes['SB']['left'] > 0 ? objMovRate['SBLeft']/objLanes['SB']['left'] : 0,
                'SBThru': lgThru && lgThru['SBThru'] ? lgThru['SBThru'] : 0,
                'SBRight': objLanes['SB']['right'] > 0 ? objMovRate['SBRight']/objLanes['SB']['right'] : 0,
                'EBLeft': objLanes['EB']['left'] > 0 ? objMovRate['EBLeft']/objLanes['EB']['left'] : 0,
                'EBThru': lgThru && lgThru['EBThru'] ? lgThru['EBThru'] : 0,
                'EBRight': objLanes['EB']['right'] > 0 ? objMovRate['EBRight']/objLanes['EB']['right'] : 0,
                'WBLeft': objLanes['WB']['left'] > 0 ? objMovRate['WBLeft']/objLanes['WB']['left'] : 0,
                'WBThru': lgThru && lgThru['WBThru'] ? lgThru['WBThru'] : 0,
                'WBRight': objLanes['WB']['right'] > 0 ? objMovRate['WBRight']/objLanes['WB']['right'] : 0,
            }
            setLgFlowRate(objLgRate);
            // calculating critical lane volumes
            gettingCriticalLaneVolumes(data, objLgRate, lastObj)
        }
    }

    const findV = (sum) => {
        let arr = [{min:0, max:200, factor:1.1},{min:200, max:600, factor:2},{min:600,max:800,factor:3},{min:800,max:1000,factor:4},{min:1000,max:null,factor:5}]
        let res = null;
        arr.forEach(function(it,ind) {
            if(it['max']) {
                if(sum >= it['min'] && sum < it['max'])
                    res = it['factor'];
            } else {
                if(sum >= it['min'])
                    res = it['factor'];
            }
        });
        return res;
    }

    const findPedVol = (vol) => {
        let arr = pedCat.length>0 ? pedCat : pedestrianCatalog.length> 0 ? pedestrianCatalog : [];
        let res = null;
        arr.forEach(function(it,ind) {
            if(vol === it['id'])
                res = parseFloat(it['equivalent']);
            
        });
        return res;
    }

    const findParking = (lane) => {
        let arr = [{lanes:0, factor:1},{lanes:1, factor:1.2},{lanes:2, factor:1.1},{lanes:3, factor:1.05}]
        let res = null;
        arr.forEach(function(it,ind) {
            if(lane === it['lanes']) {
                res = parseFloat(it['factor']);
            }
        });
        return res;
    }

    const gettingCriticalLaneVolumes = (data, objLgRate, lastObj) => {
        let objCritical = {};
        let leftPhasing = data['lanes_in_lane_group']['NB']['left_phasing'];
        let leftPhasingSb = data['lanes_in_lane_group']['SB']['left_phasing'];
        let leftPhasingEb = data['lanes_in_lane_group']['EB']['left_phasing'];
        let leftPhasingWb = data['lanes_in_lane_group']['WB']['left_phasing'];
        // 0 = Permitted
        // NB Left
        if(leftPhasing === 0 && leftPhasingSb === 0) {
            if(objLgRate['NBLeft'] === gettingMax(objLgRate,0,6)) {
                objCritical['NBLeft'] = objLgRate['NBLeft'];
            } else {
                objCritical['NBLeft'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                objCritical['NBLeft'] = objLgRate['NBLeft'];
            } else {
                objCritical['NBLeft'] ="";
            }
        }
        // NB Thru
        if(leftPhasing === 0) {
            if(objLgRate['NBThru'] === gettingMax(objLgRate,0,6)) {
                objCritical['NBThru'] = objLgRate['NBThru'];
            } else {
                objCritical['NBThru'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                objCritical['NBThru'] = "";
            } else {
                if(objLgRate['NBThru']>objLgRate['NBRight']){
                    objCritical['NBThru'] = objLgRate['NBThru'];
                } else {
                    objCritical['NBThru'] = "";
                }
            }
        }
        // NB Right
        if(leftPhasing === 0) {
            if(objLgRate['NBRight'] === gettingMax(objLgRate,0,6)) {
                objCritical['NBRight'] = objLgRate['NBRight'];
            } else {
                objCritical['NBRight'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                objCritical['NBRight'] = "";
            } else {
                if(objLgRate['NBThru']>objLgRate['NBRight']){
                    objCritical['NBRight'] = "";
                } else {
                    objCritical['NBRight'] = objLgRate['NBRight'];
                }
            }
        }
        //SB Left
        if(leftPhasing === 0 && leftPhasingSb === 0) {
            if(objLgRate['SBLeft'] === gettingMax(objLgRate,0,6)) {
                objCritical['SBLeft'] = objLgRate['SBLeft'];
            } else {
                objCritical['SBLeft'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                objCritical['SBLeft'] ="";
            } else {
                objCritical['SBLeft'] =objLgRate['SBLeft'];
            }
        }
        // SB Thru
        if(leftPhasingSb === 0) {
            if(objLgRate['SBThru'] === gettingMax(objLgRate,0,6)) {
                objCritical['SBThru'] = objLgRate['SBThru'];
            } else {
                objCritical['SBThru'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                if(objLgRate['SBThru']>objLgRate['SBRight']){
                    objCritical['SBThru'] = objLgRate['SBThru'];
                } else {
                    objCritical['SBThru'] = "";
                }
            } else {
                objCritical['SBThru'] = "";
            }
        }
        // SB Right
        if(leftPhasingSb === 0) {
            if(objLgRate['SBRight'] === gettingMax(objLgRate,0,6)) {
                objCritical['SBRight'] = objLgRate['SBRight'];
            } else {
                objCritical['SBRight'] = "";
            }
        } else {
            if( (objLgRate['NBLeft'] + gettingMax(objLgRate,4,6)) > (objLgRate['SBLeft'] + gettingMax(objLgRate,1,3))) {
                if(objLgRate['SBThru']>objLgRate['SBRight']){
                    objCritical['SBRight'] = "";
                } else {
                    objCritical['SBRight'] = objLgRate['SBRight'];
                }
            } else {
                objCritical['SBRight'] = "";
            }
        }
        // EB Left
        if(leftPhasingEb === 0 && leftPhasingWb === 0) {
            if(objLgRate['EBLeft'] === gettingMax(objLgRate,6,12)) {
                objCritical['EBLeft'] = objLgRate['EBLeft'];
            } else {
                objCritical['EBLeft'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                objCritical['EBLeft'] = objLgRate['EBLeft'];
            } else {
                objCritical['EBLeft'] ="";
            }
        }
        // EB Thru
        if(leftPhasingEb === 0) {
            if(objLgRate['EBThru'] === gettingMax(objLgRate,6,12)) {
                objCritical['EBThru'] = objLgRate['EBThru'];
            } else {
                objCritical['EBThru'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                objCritical['EBThru'] = "";
            } else {
                if(objLgRate['EBThru'] > objLgRate['EBRight']){
                    objCritical['EBThru'] = objLgRate['EBThru'];
                } else {
                    objCritical['EBThru'] = "";
                }
            }
        }
        // EB Right
        if(leftPhasingEb === 0) {
            if(objLgRate['EBRight'] === gettingMax(objLgRate,6,12)) {
                objCritical['EBRight'] = objLgRate['EBRight'];
            } else {
                objCritical['EBRight'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                objCritical['EBRight'] = "";
            } else {
                if(objLgRate['EBThru']>objLgRate['EBRight']){
                    objCritical['EBRight'] = "";
                } else {
                    objCritical['EBRight'] = objLgRate['EBRight'];
                }
            }
        }
        // WB Left
        if(leftPhasingEb === 0 && leftPhasingWb === 0) {
            if(objLgRate['WBLeft'] === gettingMax(objLgRate,6,12)) {
                objCritical['WBLeft'] = objLgRate['WBLeft'];
            } else {
                objCritical['WBLeft'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                objCritical['WBLeft'] ="";
            } else {
                objCritical['WBLeft'] = objLgRate['WBLeft'];
            }
        }
        // WB Thru
        if(leftPhasingWb === 0) {
            if(objLgRate['WBThru'] === gettingMax(objLgRate,6,12)) {
                objCritical['WBThru'] = objLgRate['WBThru'];
            } else {
                objCritical['WBThru'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                if(objLgRate['WBThru'] > objLgRate['WBRight']){
                    objCritical['WBThru'] = objLgRate['WBThru'];
                } else {
                    objCritical['WBThru'] = "";
                }
            } else {
                objCritical['WBThru'] = "";
            }
        }
        // WB Right
        if(leftPhasingWb === 0) {
            if(objLgRate['WBRight'] === gettingMax(objLgRate,6,12)) {
                objCritical['WBRight'] = objLgRate['WBRight'];
            } else {
                objCritical['WBRight'] = "";
            }
        } else {
            if( (objLgRate['EBLeft'] + gettingMax(objLgRate,10,12)) > (objLgRate['WBLeft'] + gettingMax(objLgRate,7,9))) {
                if(objLgRate['WBThru']>objLgRate['WBRight']){
                    objCritical['WBRight'] = "";
                } else {
                    objCritical['WBRight'] = objLgRate['WBRight'];
                }
            } else {
                objCritical['WBRight'] = "";
            }
        }
        setCriticalLaneVol(objCritical);
        updateAnalysisResult(lastObj, objCritical);
    }

    const updateAnalysisResult = (lastObj, objCritical) => {
        if(lastObj && lastObj['critical_flow_ratio']===null && !lastObj['isGlobal']) {
            let sum = 0;
            let dir = ['NB', 'SB', 'EB', 'WB'];
            dir.forEach(function(d) {
                sum += objCritical && objCritical[d+'Left'] ? objCritical[d+'Left'] : 0;
                sum += objCritical && objCritical[d+'Thru'] ? objCritical[d+'Thru'] : 0;
                sum += objCritical && objCritical[d+'Right'] ? objCritical[d+'Right'] : 0;
            });
            let ratio = intersectionCapacity>0 ? (sum/intersectionCapacity).toFixed(2) : 0;
            let data = {
                sum_critical_lane_volumes: sum,
                intersection_capacity: intersectionCapacity,
                critical_flow_ratio: ratio,
                scenario_id: lastObj['scenario_id']
            }
            try {
                axios({
                    method: 'post',
                    headers: {
                        'payload': Cookies.get('payload'),
                    },
                    data,
                    url: API_URL + API_PATH.updateAnalysisResults,
                })
                .then(async function (response) {
                        let tmp = lastObj;
                        tmp['sum_critical_lane_volumes'] = sum;
                        tmp['critical_flow_ratio'] = ratio;
                        tmp['intersection_capacity'] = intersectionCapacity;
                        setActiveScenarioObj(tmp);
                    })
                    .catch((err) => {
                        console.error(err);        
                    })
            } catch (error) {
                console.error(error);
            }
        }
    }

    const gettingMax = (obj, min, max) => {
        let arr = Object.values(obj);
        let tmp = [];
        for(let i=min; i < max; i++) {
            tmp.push(arr[i]);
        }
        return Math.max(...tmp);
    }

    const handleFormatDate = (obj, format) => {
        let dt = null;
        if(format === 'yr') { 
            let tmp = new Date(obj);
            if(obj.length == 10) {
                dt = (tmp.getMonth()+1)+"/"+ (tmp.getDate()+1)+"/"+tmp.getFullYear();
            } else {
                dt = (tmp.getMonth()+1)+"/"+tmp.getDate()+"/"+tmp.getFullYear();
            }
        } else {
            if(obj.am && obj.am.startdate) {
                let tmp = obj.am.startdate.split("T");
                dt = tmp[0];
            } else if(obj.mid && obj.mid.startdate) {
                let tmp = obj.mid.startdate.split("T");
                dt = tmp[0];
            } else if(obj.pm && obj.pm.startdate) {
                let tmp = obj.pm.startdate.split("T");
                dt = tmp[0];
            }
        }
        return dt;
    }

    const gettingLongDate = () => {
        let longDt = "";
        if(activeDate) {
            props.peakData.forEach(function(obj){
                let dttmp;
                if(obj.am && obj.am.startdate) {
                    let tmp = obj.am.startdate.split("T");
                    dttmp = tmp[0];
                } else if(obj.mid && obj.mid.startdate) {
                    let tmp = obj.mid.startdate.split("T");
                    dttmp = tmp[0];
                } else if(obj.pm && obj.pm.startdate) {
                    let tmp = obj.pm.startdate.split("T");
                    dttmp = tmp[0];
                }
                if(dttmp === activeDate) {
                    longDt = obj.date;
                }
            });
        }
        return longDt;
    }

    const handleEdition = (val, node, dir, mov) => {
        let data = activeData;
        // val = (mov !== 'left_lanes_greater' && dir !== 'eother' && mov !== "parking" && node !== 'heavy_trucks') ? val : val;
        if(node === 'all_vehicle' || node === 'heavy_trucks' || node === 'pedestrians') {
            if(node === 'heavy_trucks') {
                if(val !== "" && val !== "%") {
                    val = typeof(val) === "string" ? val.replace("%", "") : val;
                    if(parseInt(val) > 100 )
                        val = 100;
                    val = parseFloat(val)/100;
                } else {
                    val = 0;
                }
            }
            data['peak_15_min_flowrate'][node][dir+" "+mov] = val;
        } else if(dir === "eother") {
            if(val.length < 5) {
                data[node][dir][mov] = val;    
            }
        } else {
            data[node][dir][mov] = val;
        }
        setActiveData(data);
        calculateGeometryTable(data);
    }

    const handleDownloadPdf = (type) => {
        setShowDownloadOpts(false);
        setActionInProgress(true);
        let tableData = preparingReportData(activeData);
        let data = {
            scenario_id: activeScenarioId,
            type,
            tableData,
            scenario_details: activeScenarioObj,
            station_id: props.stationData.station_id
        };
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                data,
                url: API_URL + API_PATH.signalPlanningPdf,
            })
            .then(async function (response) {
                    if (response && response.status == '200') {
                        let expoData = response.data.data;
                        downloadZipFile(expoData.file_name, expoData.bucket_name, expoData.folder_name);
                    } 
                })
                .catch((err) => {
                    console.error(err);        
                    setActionInProgress(false);
                })
        } catch (error) {
            console.error(error);
            setActionInProgress(false);
        }
    }

    const downloadZipFile = (file_name, bucket_name, folder_name) => {
        let OIDToken = Cookies.get('idToken');
       
        AWS.config.update(
            {
                region: 'us-west-2',
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: idintityPool,
                    Logins: {
                        [aswLogins]: OIDToken
                    }
                })
            }
        );
        AWS.config.credentials.clearCachedId();
        let s3 = new AWS.S3();
        s3.getObject({ Bucket: bucket_name, Key: folder_name + '/' + file_name }, function (
            error, data) {
            setActionInProgress(false);
            if (error != null) {
                console.log(error)
            } else {
                let blob = new Blob([data.Body], { type: data.ContentType });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = file_name;
                link.click();
            }
        });
    };

    const preparingReportData = (data) => {
        let tmp = data;
        if(tmp['lanes_in_lane_group']) {
            let lanesNode = tmp['lanes_in_lane_group'];
            let keys = Object.keys(lanesNode);
            keys.forEach(function(k) {
                lanesNode[k]['check_vol'] = checkVol[k] ? checkVol[k] : "";
                lanesNode[k]['cross_prod'] = leftCross[k] ? leftCross[k] : "";
                lanesNode[k]['opp_app'] = oppApp[k] ? oppApp[k] : "";
            });
        }
        if(tmp['adjustment_factors']) {
            let adjustmentNode = tmp['adjustment_factors'];
            adjustmentNode['pcs'] = tmp['peak_15_min_flowrate']['all_vehicle'];
            adjustmentNode['ehv'] = ehvValues;
            adjustmentNode['elt'] = eltValues;
            adjustmentNode['ert'] = ertValues;
            adjustmentNode['ep'] = epValues;
            adjustmentNode['elu'] = eluValues;
            adjustmentNode['mov_flow_rate'] = movFlowRate;
            adjustmentNode['lg_flow_rate'] = lgFlowRate;
            adjustmentNode['critical_lane_vols'] = criticalLaneVol;
        }
        tmp['analysis_results'] = {
            'sum_critical_lane_vols': sumLaneVolumes,
            'intersection_capacity': intCapacity,
            'critical_flow_ratio': capacityAssessment
        }
        return tmp;
    }

    return (
        <div className='signal-planning-cnt'>          
        {   
            actionInProgress &&
            <div className={'loading'}>
                <CircularProgress />
            </div>     
        }
            <div className='details-traffic-count'>
                <div className='tc-card'>
                    <label>Station</label>
                    <div className='md-body-card-details'>
                        <StationCard sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} turningCountDate={props.turningCountDate} pedestrianCountDate={props.pedestrianCountDate} biCycleCountDate={props.biCycleCountDate}/>
                    </div>
                </div>  
                <div className='tc-card global-scenarios' style={{marginLeft:'32px'}}>
                    <div>
                        <label>Global AM scenario </label>
                        <GlobalScenarioCard period={"AM"} scenariosList={scenariosList} globalDefaultTitle={globalDefaultTitle} globalDefaultDesc={globalDefaultDesc} capacityCat={capacityRatioCat} handleFormatDate={handleFormatDate} noCountDataTxt={noCountDataTxt} />
                    </div>
                    <div>
                        <label>Global MID scenario </label>
                        <GlobalScenarioCard period={"MID"} scenariosList={scenariosList} globalDefaultTitle={globalDefaultTitle} globalDefaultDesc={globalDefaultDesc} capacityCat={capacityRatioCat} handleFormatDate={handleFormatDate} noCountDataTxt={noCountDataTxt} />
                    </div>
                    <div>
                        <label>Global PM scenario </label>
                        <GlobalScenarioCard period={"PM"} scenariosList={scenariosList} globalDefaultTitle={globalDefaultTitle} globalDefaultDesc={globalDefaultDesc} capacityCat={capacityRatioCat} handleFormatDate={handleFormatDate} noCountDataTxt={noCountDataTxt} />
                    </div>
                </div>
            </div>  
            <div className='scenario-viewer'>
                <ButtonGroup color="primary" aria-label="outlined primary button group">
                    <DataIconsTooltip title="Export PDF"><Button disabled={scenariosList.length===0} onClick={() => setShowDownloadOpts(true)}><img src={require('../../../assets/icons/planning/download.svg')} /></Button></DataIconsTooltip>
                    <DataIconsTooltip title="Adjustment factors"><Button disabled={scenariosList.length===0} onClick={()=>setShowAdvancedOpt(true)}>
                        {showAdvancedInputs ? <img src={require('../../../assets/icons/planning/settings_active.svg')}/> : <img src={require('../../../assets/icons/planning/settings.svg')}/> }
                    </Button></DataIconsTooltip>
                    <DataIconsTooltip title="Open Lane geometry"><Button disabled={!getPrivileges().includes(1)} 
                        onClick={() => {setShowLaneConfig(true); setReadOnly(true)}}><img src={require('../../../assets/icons/planning/intersection_group.svg')} /></Button></DataIconsTooltip> {/** disabled={scenariosList.length===0} */}
                    <DataIconsTooltip title="Delete current scenario"><Button disabled={isShared || scenariosList.length === 0 || !getPrivileges().includes(1) || (activeScenarioObj && activeScenarioObj['isGlobal'])}>
                        <img src={require('../../../assets/icons/planning/trash.svg')} onClick={handleDeleteScenario} />
                    </Button></DataIconsTooltip>
                    <DataIconsTooltip title="Refresh current scenario"><Button disabled={isShared || !editable}><img src={require('../../../assets/icons/planning/reset.svg')} onClick={handleClearInfo}/></Button></DataIconsTooltip>
                </ButtonGroup>
                <div className='tt'>{ scenariosList.length > 0 ? 
                    <Select                  
                        className="select-dp slc-time-perido-details"                                     
                        value={scenariosList.length > 0 ? activeScenarioId : null}
                        height='38px'                               
                        onChange={handleChangeScenario}
                        IconComponent={ExpandMoreIcon}
                        MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                    >   
                    {
                        scenariosList.map((val) => {
                            return <MenuItem value={val.scenario_id}>{val.name}</MenuItem>                        
                        })
                    }                                    
                    </Select>
                 : <label>Scenario viewer</label>}</div>
                <div>
                    {
                        (!isShared && activeScenarioId) &&
                        <Button 
                            className='cancel-btn edit-sc-btn'
                            onClick={ handleCancel }
                            disabled={!getPrivileges().includes(1) || (activeScenarioObj && activeScenarioObj['isGlobal'])}
                        >
                            { editable ? 'Cancel' : 'Edit'}</Button>
                    }
                    <Button 
                        className='blue-btn create-sc-btn'
                        disabled={props.sharedStation || !props.hasData || !props.stationData.FK_lane_config_id || !getPrivileges().includes(1)}
                        onClick={handleActionButton}
                    >
                        {!editable &&
                        <img src={require('../../../assets/icons/file_add.svg')} /> 
                        }
                        { editable ? 'Save' : 'Create scenario'}</Button>
                </div>
                {
                    showDownloadOpts &&
                    <ClickAwayListener onClickAway={()=> setShowDownloadOpts(false)}>
                        <div className="export-actions" data-testid="actionsContainer">
                            <ul>
                                {/* <li ><img src={require('../../../assets/icons/file_download.svg')} /> Export CSV</li>
                                <li className="divisor"></li> */}
                                <li onClick={()=>handleDownloadPdf('condensed')} ><img src={require('../../../assets/icons/file_download.svg')} /> Export condensed PDF</li>
                                <li className="divisor"></li>
                                <li onClick={()=>handleDownloadPdf('extended')} ><img src={require('../../../assets/icons/file_download.svg')} /> Export extended PDF</li>
                            </ul>
                        </div>
                    </ClickAwayListener>
                }
                {
                    showAdvancedOpt &&
                    <ClickAwayListener onClickAway={()=> setShowAdvancedOpt(false)}>
                        <div className="advanced-inputs">
                            <FormControlLabel
                                control={<IOSSwitch checked={showAdvancedInputs} onChange={(e) => setShowAdvancedInputs(e.target.checked)} />}
                                label="Show adjustment factors (scroll down to view)"
                            />
                        </div>
                    </ClickAwayListener>
                }
                
            </div>  
            {
                !activeScenarioId ?
                    gettingEmptyState()
                :
                <div className='not-empty-state'>
                    <div className='summary-desc'>
                        <div className='tc-card'>
                            <label>Scenario summary</label>
                            <Card className='details-main-info'>
                                <div className='main-summary'>
                                    {
                                        capacityRatioCat.map(function(it, ind){
                                            if( (capacityAssessment >= it['min'] && capacityAssessment < it['max']) || (!it['max'] && capacityAssessment >= it['min'])) {
                                                return <div className={ind===0 ? 'capacity-ratio emerald-txt' : ind===1 ? 'capacity-ratio amber-txt' : 'capacity-ratio red-txt'}>
                                                    <label className='indicator'></label>
                                                    <label>{it['capacity']}</label>
                                                </div>
                                            }
                                        })
                                    }
                                    <div className='scenario-summary'>
                                        <div>
                                            <label className='light-small-lbl'>Created by</label>
                                            <label className='dark-small-lbl'>{activeScenarioObj ? (activeScenarioObj['isGlobal'] ? "Data Point" : activeScenarioObj['created_by']) : ""}</label>
                                        </div>
                                        <div>
                                            <label className='light-small-lbl'>Created on</label>
                                            <label className='dark-small-lbl'>{activeScenarioObj ? handleFormatDate(activeScenarioObj['createdAt'],'yr') : ""}</label>
                                        </div>
                                        <div>
                                            <label className='light-small-lbl'>Last modified</label>
                                            <label className='dark-small-lbl'>{activeScenarioObj ? handleFormatDate(activeScenarioObj['updatedAt'],'yr') : ""}</label>
                                        </div>
                                        <div>
                                            <label className='light-small-lbl'>Critical flow ratio</label>
                                            <label className='dark-small-lbl'>{activeScenarioObj ? activeScenarioObj['critical_flow_ratio'] : ""}</label>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className='tc-card'>
                            <label>Description</label>
                            <Card className='details-main-info'>
                                <div className='scenario-desc'>
                                    {
                                        editable ? 
                                        <textarea className='dark-small-lbl' type='text' onChange={(e)=>setDescriptionScenario(e.target.value)} value={descriptionScenario} maxLength={250}/>
                                        :
                                        <label className='dark-small-lbl'>{activeScenarioObj ? activeScenarioObj['description'] : ""}</label>
                                    }
                                </div>
                            </Card>
                        </div>
                        <div className='tc-card'>
                            <label>Count date & time</label>
                            <div className='date-time-cnt'>        
                                <Grid item xs={8}>  
                                {
                                    editable ? 
                                    <Select                  
                                        className="select-dp slc-time-perido-details"                                     
                                        value={activeDate}
                                        height='38px'                               
                                        onChange={handleChangeDate}
                                        IconComponent={ExpandMoreIcon}
                                        MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                                        disabled={!editable}
                                    >
                                        {props.peakData.map((val, index) => {
                                            return <MenuItem value={handleFormatDate(val)}>{val.date}</MenuItem>                        
                                        })
                                        }                                    
                                    </Select>
                                    :
                                    gettingLongDate()
                                }              
                                </Grid>
                                <Grid item xs={4} style={{textAlign:'center',paddingLeft: '5px'}}>
                                    {
                                        editable ? 
                                        <Select             
                                            className="select-dp"                       
                                            value={activePeriod} 
                                            onChange={handleChangePeriod}
                                            height='38px'     
                                            IconComponent={ExpandMoreIcon}   
                                            MenuProps={{PaperProps:{className:'slct-details-cmp'}}}  
                                            disabled={!editable}                   
                                        >
                                        <MenuItem value='AM' disabled={!periodList.includes("AM")}>AM</MenuItem>
                                        <MenuItem value='MID' disabled={!periodList.includes("MID")}>MID</MenuItem>                
                                        <MenuItem value='PM'disabled={!periodList.includes("PM")}>PM</MenuItem>
                                        </Select>
                                        :
                                        activePeriod
                                    }
                                </Grid>
                            </div>   
                        </div>
                    </div>
                    <TrafficTable 
                        editable={editable} 
                        pedestrianCatalog={pedestrianCatalog} 
                        activeData={activeData}
                        handleEdition={handleEdition}
                    />
                    <GeometryTable 
                        editable={editable} 
                        phasingList={phasingList} 
                        activeData={activeData}
                        checkVol={checkVol}
                        leftCross={leftCross}
                        oppApp={oppApp}
                        handleEdition={handleEdition}
                    />
                    {
                        showAdvancedInputs &&
                        <AdjusmentTable 
                            editable={editable} 
                            activeData={activeData}
                            ehvValues={ehvValues}
                            eltValues={eltValues}
                            ertValues={ertValues}
                            epValues={epValues}
                            eluValues={eluValues}
                            movFlowRate={movFlowRate}
                            lgFlowRate={lgFlowRate}
                            criticalLaneVol={criticalLaneVol}
                            handleEdition={handleEdition}
                        />
                    }
                    <MovAnalysisTable 
                        activeScenarioObj={activeScenarioObj}
                        setActiveScenarioObj={setActiveScenarioObj}
                        editable={editable} 
                        activeData={activeData}
                        criticalLaneVol={criticalLaneVol}
                        capacityAssessment={capacityAssessment}
                        setCapacityAssessment={setCapacityAssessment}
                        intCapacity={intCapacity}
                        setIntCapacity={setIntCapacity}
                        capacityRatioCat={capacityRatioCat}
                        setSumLaneVolumes={setSumLaneVolumes}
                    />
                    <div className='footer'>
                        <label>See Highway Capacity Manual (HCM) 2010 - Exhibit 31- 37 Page 13 </label>
                    </div>
                </div>
            }
            {
                (showLaneConfig) &&
                <LaneGeometry 
                    lat={props.stationData.latitude}
                    long={props.stationData.longitude}
                    stationType={props.station_type}
                    setShowLaneConfig={setShowLaneConfig}
                    approachesForLane={[
                        { eb_approach: props.stationData.eb_approach },
                        { nb_approach: props.stationData.nb_approach },
                        { sb_approach: props.stationData.sb_approach },
                        { wb_approach: props.stationData.wb_approach }
                    ]}
                    stationId={props.stationData.station_id}
                    laneConfigId={laneConfigId}                    
                    _setLaneConfigId={setLaneConfigId}
                    readOnly={readOnly}
                    setReadOnly={setReadOnly}
                    isEditingFromSignalPlanning={true}
                    //setLaneConfigId={props.stationData.FK_lane_config_id}
                    showLaneConfig={showLaneConfig}
                    setReloadScenarios={props.setReloadScenarios}
                    fromSignal={true}
                /> 
            }
        </div>
    )

}

export default SignalPlanning;